import React from 'react';
import { Sentry, captureException } from '../util/sentry';
import App from 'next/app';
import Router from 'next/router';
const UserAgentParser = require('../common/UserAgentParser');
import AmplitudeEventLogger from '../components/common/amplitudeEventLogger';
import FacebookPixelEventLogger from '../components/common/facebookPixelEventLogger';
import HotjarLogger from '../components/common/hotjarLogger';
import IntercomWidget from '../components/common/intercomWidget';
import FreshChatWidget from '../components/common/freshChatWidget';
import NotifyUnauthorizedDomain from '../components/common/notifyUnauthorizedDomain';
import TestingBanner from '../components/common/testingBanner';
import DeviceInfoContext from '../components/common/deviceInfoContext';
import RequestInfoContext from '../components/common/requestInfoContext';

import '../css/index.scss';
export default class GiveApp extends App {
	constructor() {
		super(...arguments);

		if (arguments[0] && arguments[0].pageProps) {
			this.updatePagePropsForBrowser(arguments[0].pageProps);
		}

		this.state = {
			hasError: false,
			errorEventId: undefined,
		};
	}

	static async getInitialProps({ Component, ctx }) {
		let pageProps = {};
		try {
			if (Component.getInitialProps) {
				pageProps = await Component.getInitialProps(ctx);
			}

			this.setDeviceInfoOnPageProps(pageProps, ctx);
			this.setRequestInfoOnPageProps(pageProps, ctx);

			return { pageProps };
		} catch (error) {
			const errorEventId = captureException(error, ctx);

			return {
				hasError: true,
				errorEventId,
				pageProps,
			};
		}
	}

	static setDeviceInfoOnPageProps(pageProps, ctx) {
		if (ctx && ctx.req && ctx.req.logInfo && ctx.req.logInfo.deviceInfo) {
			pageProps.deviceInfo = ctx.req.logInfo.deviceInfo;
		}
	}

	static setRequestInfoOnPageProps(pageProps, ctx) {
		if (ctx && ctx.req) {
			const req = ctx.req;

			pageProps.requestInfo = {
				host: req.get('host'),
				method: req.method,
				path: req.baseUrl + req.path,
				params: req.params,
				query: req.query,
				secure: req.secure,
			};
		}
	}

	static getDerivedStateFromProps(props, state) {
		return {
			hasError: props.hasError || state.hasError || false,
			errorEventId: props.errorEventId || state.errorEventId || undefined,
		};
	}

	// TODO should we show error page on every exception?
	static getDerivedStateFromError() {
		return { hasError: true };
	}

	// componentDidCatch(error, errorInfo) {
	// 	const errorEventId = captureException(error, { errorInfo });
	// 	this.setState({ errorEventId, hasError: true });
	// }

	componentDidMount() {
		// NOTE: this disables client routing completely
		Router.beforePopState(function () {
			return false;
		});
	}

	updatePagePropsForBrowser(pageProps) {
		if (!window) {
			return;
		}

		if (pageProps.store) {
			pageProps.store.width = window.innerWidth;
		}

		if (
			pageProps.deviceInfo &&
			window.navigator &&
			window.navigator.userAgent
		) {
			pageProps.deviceInfo = UserAgentParser.deviceInfo(
				window.navigator.userAgent
			);
		}
	}

	render() {
		if (this.state.hasError) {
			return (
				<section className="text-center">
					<h1>Ouch! We encountered an error!</h1>
					<p>
						<a
							href="#"
							onClick={() =>
								Sentry.showReportDialog({ eventId: this.state.errorEventId })
							}
						>
							Report this error
						</a>
					</p>
					<p>OR</p>
					<p>
						<a
							href="#"
							onClick={() => {
								window.location.reload(true);
							}}
						>
							Try reloading the page
						</a>
					</p>
				</section>
			);
		}

		const { Component, pageProps } = this.props;

		return (
			<React.Fragment>
				<DeviceInfoContext.Provider value={pageProps.deviceInfo}>
					<RequestInfoContext.Provider value={pageProps.requestInfo}>
						<Component {...pageProps} />
					</RequestInfoContext.Provider>
				</DeviceInfoContext.Provider>

				<AmplitudeEventLogger
					AB={pageProps.AB}
					pageType={pageProps.pageType}
					data={pageProps.data}
					tenantConfig={pageProps.store.tenantConfig}
					amount={pageProps.amount}
				/>
				<FacebookPixelEventLogger
					AB={pageProps.AB}
					tenantConfig={pageProps.store.tenantConfig}
				/>
				<HotjarLogger tenantConfig={pageProps.store.tenantConfig} />
				<IntercomWidget
					session={pageProps.session}
					tenantConfig={pageProps.store.tenantConfig}
				/>
				{window &&
				window.location &&
				window.location.pathname.includes('/deed/donate') ? null : (
					<FreshChatWidget
						session={pageProps.session}
						tenantConfig={pageProps.store.tenantConfig}
					/>
				)}
				<NotifyUnauthorizedDomain notify={false} />
				<TestingBanner />
			</React.Fragment>
		);
	}
}
